import React from 'react'
import Typography from '@mui/material/Typography'

const SectionTitle = ({ title }: { title: string }) => {
  return (
    <Typography
      variant="h5"
      align="center"
      sx={{ fontWeight: '600', fontFamily: 'SpaceGrotesk, sans-serif' }}>
      {title}
    </Typography>
  )
}

export default SectionTitle
